import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Color } from 'styles/types'
import { ReactNode } from 'react'
import { StyledLegend } from './styles'

interface ModalFooterListItemProps {
    badge?: string | null
    children: ReactNode
    legendColor: Color
}

const ModalFooterListItem = ({
    badge = null,
    children,
    legendColor,
}: ModalFooterListItemProps) => (
    <Box direction="row">
        <Box direction={'row'} gap={8}>
            <StyledLegend color={legendColor}>
                {!!badge && <img src={badge} alt="" />}
            </StyledLegend>
            <Text variant="bodyExtraSmall" color="grayscale_700">
                {children}
            </Text>
        </Box>
    </Box>
)

export default ModalFooterListItem
